import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-decrease',
  templateUrl: './icon-decrease.component.html',
  styleUrls: ['./icon-decrease.component.scss']
})
export class IconDecreaseComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
